import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, IconButton, Button, Grid
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { post } from "mdui/api/HttpReq"; 
import { AlertType } from 'mdui/page/MsgBox';
import { useUtil } from "mdui/page/UtilProvider";

export default function RunJobModal({ open, onClose, defaultParams }) {
  const [params, setParams] = useState([]);
  
   const {openModel} = useUtil();

  useEffect(() => {
    if (open && defaultParams) {
      setParams([
        { key: 'executeJob', value: defaultParams.batchName },
        { key: 'PARAM_1', value: defaultParams.param1 }
      ]);
    }
  }, [open, defaultParams]);

  const handleAddParam = () => setParams([...params, { key: '', value: '' }]);

  const handleRemoveParam = (index) => {
    const newParams = [...params];
    newParams.splice(index, 1);
    setParams(newParams);
  };

  const handleParamChange = (index, field, value) => {
    const newParams = [...params];
    newParams[index][field] = value;
    setParams(newParams);
  };


  const handleRunJob = async () => {
		console.log('Running Job with params:', params);
    const param = {
			parameters: params
		};
		const res = await post("runJob", "list", param);
		console.log(res);
		 if (res?.error) {
			 openModel({ msg: res?.error, type: AlertType.E });
    }else{
		openModel({ msg: res?.message, type: AlertType.I });
	}
    onClose();
	};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Execute Batch Job
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {params.map((param, index) => (
          <Grid container spacing={2} alignItems="center" key={index} sx={{ mb: 1 }}>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Key"
                value={param.key}
                onChange={(e) => handleParamChange(index, 'key', e.target.value)}
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Value"
                value={param.value}
                onChange={(e) => handleParamChange(index, 'value', e.target.value)}
              />
            </Grid>
            <Grid item xs={2}>
              {index === 0 ? (
                <IconButton onClick={handleAddParam} color="primary">
                  <AddIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => handleRemoveParam(index)} color="error">
                  <RemoveIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button onClick={handleRunJob} variant="contained" color="primary">
          Run Job
        </Button>
      </DialogActions>
    </Dialog>
  );
}
